var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad-group-simple-editor" },
    [
      _c("AdGroupForm", {
        ref: "adGroupForm",
        attrs: {
          "is-edit": _vm.isEdit,
          "is-simple-mode": true,
          "banner-templates": _vm.bannerTemplates,
        },
        on: {
          "template-change": _vm.handleTemplateChange,
          change: _vm.handleFormChange,
        },
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
      _c("BannerPosition", {
        ref: "bannerPosition",
        attrs: {
          "slot-keys": _vm.slotKeys,
          "is-edit": _vm.isEdit,
          "is-simple-mode": true,
          "default-banners": _vm.defaultBanners,
        },
        on: { change: _vm.handleBannerPositionChange },
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }